module.exports = __webpack_public_path__ + "img/ewm-lxc.3b7ee0d7.png";